/** @format */

import React, { useCallback, useEffect, useRef, useState } from "react";
import Switch from "components/1tyons/Switch";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { useAppStore } from "store/useAppStore";

interface UploadGarmentsCardProps {
  uploadedImageUrl: string;
  handleUpload: (event: React.ChangeEvent<HTMLInputElement>) => void;
  title: string;
  placeholder: string;
  clearImage: () => void;
}

const UploadGarmentsCard = ({
  uploadedImageUrl,
  handleUpload,
  title,
  placeholder,
  clearImage,
}: UploadGarmentsCardProps) => {
  const [enable, setEnable] = useState(true);
  const [isLoaded, setIsLoaded] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const cameraInputRef = useRef<HTMLInputElement>(null);

  const handleSwitchClick = () => {
    setEnable(!enable);
  };

  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  const handleCameraClick = () => {
    cameraInputRef.current?.click();
  };

  useEffect(() => {
    if (uploadedImageUrl.length) {
      setEnable(true);
    }
  }, []);

  return (
    <div>
      <div className="text-white w-full flex justify-between items-center">
        <h3 className="text-[1.6rem] font-semibold">{title}</h3>
        <div>
          <Switch handleSwitch={handleSwitchClick} enable={enable} />
        </div>
      </div>
      <div className="bg-darkgray h-[20rem] mx-auto grid place-items-center mt-[1rem] rounded-xl border border-lightborder">
        {uploadedImageUrl ? (
          <div className="w-full ">
            <img
              onLoad={() => setIsLoaded(true)}
              className={`w-[70%] h-[17rem] mx-auto rounded-xl transition-opacity duration-700 ease-in-out object-cover ${
                isLoaded ? "opacity-100" : "opacity-0"
              } `}
              src={uploadedImageUrl}
              alt="Uploaded"
            />
          </div>
        ) : (
          <p
            className={` ${
              !enable && "text-disable"
            } text-white text-center px-[1rem] font-medium`}
          >
            {placeholder}
          </p>
        )}
      </div>
      {!uploadedImageUrl ? (
        <div className="flex w-full gap-[2rem] mt-[2rem]">
          <button
            onClick={handleUploadClick}
            disabled={!enable}
            className={`${
              !enable && "!text-disable !border-disable"
            } w-full border-2 border-white text-white text-[1.1rem] font-semibold px-[1rem] py-[0.4rem] rounded-xl transition-all duration-200 ${
              enable &&
              "hover:bg-turquoise hover:text-black hover:border-turquoise"
            }`}
          >
            Upload Image
          </button>
          <button
            disabled={!enable}
            onClick={handleCameraClick}
            className={`${
              !enable && "!text-disable !border-disable"
            } w-full border-2 border-white text-white text-[1.1rem] font-semibold px-[1rem] py-[0.4rem] rounded-xl transition-all duration-200 ${
              enable &&
              "hover:bg-turquoise hover:text-black hover:border-turquoise"
            }`}
          >
            Take a Picture
          </button>
        </div>
      ) : (
        <div className="flex w-full gap-[2rem] mt-[2rem]">
          <button
            disabled={!enable}
            onClick={handleUploadClick}
            className={`${
              !enable && "!text-disable !border-disable"
            } w-full border-2 border-white text-white text-[1.1rem] font-semibold px-[1rem] py-[0.4rem] rounded-xl transition-all duration-200 ${
              enable &&
              "hover:bg-turquoise hover:text-black hover:border-turquoise"
            }`}
          >
            Change Image
          </button>
          <button
            disabled={!enable}
            onClick={clearImage}
            className={`${
              !enable && "!text-disable !border-disable"
            } text-[#FF0000] border-[#FF0000] w-full border-2 text-[1.1rem] font-semibold px-[1rem] py-[0.4rem] rounded-xl transition-all duration-200 ${
              enable &&
              " hover:bg-[#FF0000] hover:text-white hover:border-[#FF0000]"
            }`}
          >
            Remove
          </button>
        </div>
      )}
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleUpload}
        style={{ display: "none" }}
        accept="image/*"
      />
      <input
        type="file"
        ref={cameraInputRef}
        onChange={handleUpload}
        style={{ display: "none" }}
        accept="image/*"
        capture="environment"
      />
    </div>
  );
};

export default UploadGarmentsCard;
